import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home';
import Login from '../views/Login';
import Dashboard from '../views/Dashboard';
import Files from '../views/Files';
import Account from '../views/Account';
import Users from '../views/Users';
import Certificates from '../views/Certificates';
import FormUser from '../views/FormUser';
import Teams from '../views/Teams';
import Events from '../views/Events';
import Announcements from '../views/Announcements';
import Activities from '../views/Activities';
import Indicatives from '../views/Indicatives';
import About from '../views/About';
import Goals from '../views/Goals';
import FAQ from '../views/FAQ';
import Team from '../views/Team';
import PrivateFiles from '../views/PrivateFiles';

// eslint-disable-next-line import/no-cycle
import { routerMiddlewares } from './middlewares';
import { profiles } from '../utils/Profiles';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/about',
    name: 'About',
    component: About,
  },
  {
    path: '/goals',
    name: 'Goals',
    component: Goals,
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ,
  },
  {
    path: '/team',
    name: 'Team',
    component: Team,
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      isAuth: true,
    },
  },
  {
    path: '/files',
    name: 'Files',
    component: Files,
    meta: {
      isAuth: true,
    },
  },
  {
    path: '/private-files',
    name: 'PrivateFiles',
    component: PrivateFiles,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
        profiles.MONITOR_BOLSISTA,
        profiles.MONITOR_VOLUNTARIO,
      ],
    },
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      isAuth: true,
    },
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
        profiles.MONITOR_VOLUNTARIO,
        profiles.MONITOR_BOLSISTA,
      ],
    },
  },
  {
    path: '/certificates',
    name: 'Certificates',
    component: Certificates,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
      ],
    },
  },
  {
    path: '/user',
    name: 'FormUser',
    component: FormUser,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
        profiles.MONITOR_VOLUNTARIO,
        profiles.MONITOR_BOLSISTA,
      ],
    },
    props: true,
  },
  {
    path: '/teams',
    name: 'Teams',
    component: Teams,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
      ],
    },
  },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
      ],
    },
  },
  {
    path: '/announcements',
    name: 'Announcements',
    component: Announcements,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
      ],
    },
  },
  {
    path: '/activities',
    name: 'Activities',
    component: Activities,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
        profiles.MONITOR_BOLSISTA,
        profiles.MONITOR_VOLUNTARIO,
      ],
    },
  },
  {
    path: '/indicatives',
    name: 'Indicatives',
    component: Indicatives,
    meta: {
      isAuth: true,
      allowedProfilesIds: [
        profiles.ADMINISTRADOR,
        profiles.COORDENADOR_DISCENTE,
        profiles.COORDENADOR_DOCENTE,
        profiles.MONITOR_BOLSISTA,
        profiles.MONITOR_VOLUNTARIO,
        profiles.EDUCANDO,
      ],
    },
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach(routerMiddlewares);

export default router;
